<template>
  <div class="row">
    <div class="col-md-8">
      <div class="card card-default">
        <service-wizard-layout
          title=""
          subtitle=""
          :parts="parts"
          :onComplete="onComplete"
          :validateStep="validateStep"
        >
          <template v-slot:virtualserverdetails>
            <form novalidate data-vv-scope="virtualserverdetails">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group">
                    <label class="control-label">Name: </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="filledInSaleDefinition.requiredObjs.virtualServer.name"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group">
                    <label class="control-label">UUID: </label>
                    <input
                      type="text"
                      class="form-control"
                      name="UUID"
                      v-model="filledInSaleDefinition.requiredObjs.virtualServer.uuid"
                    />
                  </div>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:package>
            <form novalidate data-vv-scope="package" v-if="!filledInSaleDefinition.requiredObjs.virtualServerPackage">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group"
                    :class="{
                      'has-error': errors.has('package.Package'),
                    }">
                    <label class="control-label">Package *</label>
                    <v-select
                      name="packSelect"
                      placeholder="Select Package"
                      :options="sortedPackages"
                      @input="packageSelected"
                      label="description"
                    ></v-select>
                    <input
                      type="text"
                      class="form-control"
                      name="Package"
                      v-show="false"
                      v-validate="'min_value:1'"
                      v-model="filledInSaleDefinition.requiredObjs.virtualServer.virtualServerPackageNumber"
                    />
                    <span class="has-error" v-if="errors.has('package.Package')">Must select a package</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group">
                    <label class="control-label">Virtual RAM</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        :value="sizeBytesToGb(selectedPackage.virtualRam)"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">GB</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Virtual CPUs</label>
                    <input
                      type="text"
                      class="form-control"
                      readonly
                      :value="selectedPackage.virtualCPUs"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Disk Space</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        :value="sizeBytesToGb(selectedPackage.diskSpace)"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">GB</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Data Bundle Size</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        :value="sizeBytesToGb(selectedPackage.dataBundleSize)"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">GB</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <form novalidate data-vv-scope="package" v-else>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div class="form-group">
                    <label class="control-label">Virtual RAM</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="filledInSaleDefinition.requiredObjs.virtualServerPackage.virtualRam"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">GB</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Virtual CPUs</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="filledInSaleDefinition.requiredObjs.virtualServerPackage.virtualCPUs"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Disk Space</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="filledInSaleDefinition.requiredObjs.virtualServerPackage.diskSpace"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">GB</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-if="filledInSaleDefinition.requiredObjs.virtualServerPackage">
                    <label class="control-label">Data Bundle Size</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="filledInSaleDefinition.requiredObjs.virtualServerPackage.dataBundleSize"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">GB</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </template>
        </service-wizard-layout>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceWizardLayout from "@/layouts/ServiceWizardLayout";
export default {
  components: {
    ServiceWizardLayout,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parts: [
        {
          name: "virtualserverdetails",
          displayName: "Virtual Server Details",
        },
        {
          name: "package",
          displayName: "Virtual Server Package",
        },
      ],
      filledInSaleDefinition: {
        requiredObjs: {
          virtualServer: {},
        },
        selectableOptions: {
          virtualServerPackage: [],
        },
      },
      selectedPackage: {},
      networkOptions: [],
    };
  },
  mounted() {
    this.filledInSaleDefinition = this.emptySaleDefinition;
    
    if (this.filledInSaleDefinition.selectableOptions.virtualServerPackage) {
      this.filledInSaleDefinition.selectableOptions.virtualServerPackage = this.filledInSaleDefinition.selectableOptions.virtualServerPackage.filter(pak => pak.productNumber == this.filledInSaleDefinition.product.productNumber);
    }
  
    this.networkOptions = this.filledInSaleDefinition.selectableOptions.internetNetworkGroup;

    //if there is a sku, then filter out all but the pre-selected objKey
    if (this.$route.query.sku) {
      let preSelectedObjKey = this.$route.query.sku.split('-',3)[2];  
      var onlyOne = this.filledInSaleDefinition.selectableOptions.virtualServerPackage.filter( pack => pack.virtualServerPackageNumber == preSelectedObjKey);
      if (onlyOne.length == 1) {
        this.filledInSaleDefinition.selectableOptions.virtualServerPackage = onlyOne;
      }
    }

  },
  computed: {
    isHostAfrica() {
      if (this.filledInSaleDefinition.product.productDefinition == "HostAfricaServerService") {
        return true
      } else {
        return false
      }
    },
    sortedPackages() {
      const packages = this.filledInSaleDefinition?.selectableOptions?.virtualServerPackage;
      if (!Array.isArray(packages)) return [];
      return [...packages].sort((a, b) => a.label.localeCompare(b.label));
    }
  },
  methods: {
    packageSelected(virtualServerPackage) {
      this.filledInSaleDefinition.requiredObjs.virtualServer.virtualServerPackageNumber = virtualServerPackage.virtualServerPackageNumber;
      this.selectedPackage = this.deepCopyObject(virtualServerPackage);
    },
    onComplete() {
      if (this.filledInSaleDefinition.requiredObjs.virtualServerPackage) {
        this.filledInSaleDefinition.requiredObjs.virtualServerPackage.virtualRam = parseFloat(this.sizeGbToBytes(this.filledInSaleDefinition.requiredObjs.virtualServerPackage.virtualRam))
        this.filledInSaleDefinition.requiredObjs.virtualServerPackage.diskSpace = parseFloat(this.sizeGbToBytes(this.filledInSaleDefinition.requiredObjs.virtualServerPackage.diskSpace))
      }
      this.$emit("createSale", this.filledInSaleDefinition);
    },
    validateStep(scope) {
      return this.$validator.validateAll(scope).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>
